export default function ProjectDetails({ project }) {
  return [project.client?.name, project.name].filter(Boolean).join(' - ');
}
